module.exports = __webpack_public_path__ + "img/rooms.cc181e2d.jpg";